<template>
  <!-- 信息发布 -->
  <div class="page-solicitation">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form @keyup.enter.native="getTableList"  class="com-search-box" ref="form" :model="form" label-width="80px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="标题 :" prop="title">
              <el-input v-model="form.title" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="信息类型 :" prop="type">
              <el-select v-model="form.type" placeholder="请选择">
                <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="com-head-search-btns">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="restList">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button" v-if="from != 1">
        <el-row>
          <el-button class="el-primary-border" round @click="handleCreate('add')">
            <svg-icon icon-class="add" />&nbsp;发布
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :row-key="(row)=>{ return row.schemeId }" :data="tableData" :cell-class-name="(item)=>{ if(item.columnIndex==1) return 'g-column-light-box'}">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column label="标题" min-width="20%" show-overflow-tooltip>
            <template slot-scope="scope">
              <router-link class="m-btn" target="_blank" :to="{path: '/approve/notice-detail', query: {obj:encodeURIComponent(JSON.stringify(scope.row))}}">{{ scope.row.title }}</router-link>
            </template>
          </el-table-column>
          <el-table-column prop="typeName" label="信息类型" min-width="15%"></el-table-column>
          <el-table-column prop="createTimeStr" label="创建时间" min-width="15%">
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.createTimeStr, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createrName" label="创建人" min-width="14%"></el-table-column>
          <el-table-column prop="statusName" label="发布状态" min-width="14%"></el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="15%" v-if="from != 1">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handlePublish(scope.row)">{{scope.row.status === '2' ? '取消发布' : '发布'}}</a>

              <a class="m-btn mr-10" @click="handleCreate('edit', scope.row.informationId)" v-if="scope.row.status != '2'">编辑</a>

              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row.informationId)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <dialogCreateInfo ref="dialogCreateInfo" @refresh="restList"></dialogCreateInfo>
  </div>
</template>

<script>
import cmpMyExport from '@cmp/my-export'
import dialogCreateInfo from './dialog-create-info'
export default {
  components: {
    cmpMyExport,
    dialogCreateInfo
  },
  data() {
    return {
      form: {
        title: '',
        // type: ''
      },
      from: 0,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      typeList: [],
      tableData: [],
      listLoading: true,
    }
  },
  methods: {
    // 初始化表格
    initList(type) {
      this.listLoading = true
      if (this.from == 1) {
        // 信息发布列表
        this.$http.get('/bsInformation/commonList', {
          type: '1',
          ...this.listQuery,
          ...this.form
        }).then(res => {
            this.listLoading = false
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow
          }
        })
      } else {
        this.$http
          .get('/bsInformation/list', {
            ...this.listQuery,
            ...this.form
          })
          .then(res => {
            this.listLoading = false
            if (res.success) {
              if (
                type === 'dele' &&
                this.listQuery.currentPage > 1 &&
                !res.result.length
              ) {
                this.listQuery.currentPage -= 1
                this.initList()
                return
              }
              this.tableData = res.result
              this.total = res.page.allRow
            } else {
              this.$message.error(res.message)
            }
          })
      }
    },

    // 获取下拉状态选择值
    getDropdownValue() {
      this.$http
        .get('/collectDict/getSelectDataByKey', { key: 'information_type' })
        .then(res => {
          if (res.success) {
            var state = res.result
            let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.typeList = firstArr.concat(state)
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 重置查询
    restList() {
      this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(id) {
      this.$common.confirm(
        {
          title: '删除信息发布',
          content: '该信息发布将被删除，请谨慎操作'
        },
        () => {
          this.$http
            .post('/bsInformation/delete', {
              informationId: id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('信息发布删除成功')
                this.initList('dele')
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    handlePublish(item) {
      this.$http
        .post('/bsInformation/publicOrNot', {
          informationId: item.informationId,
          status: item.status === '2' ? '1' : '2', // 1-取消发布 2-发布
        })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handleCreate(type, id) {
      this.$refs.dialogCreateInfo.init(type, id)
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    }
  },
  created() {
    this.from = this.$route.query.type
    this.initList()
    this.getDropdownValue()
  }
}
</script>

<style lang="scss" scoped>
</style>